module.exports = __webpack_public_path__ + "front/img/p1_2.76f35ef1.png";